import { CategoryRepository } from '../repositories/CategoryRepository';
import { CreateCategoryDto } from '../dtos/CategoryDto';

export class CategoryService {
    static async getCategories() {
        try {
            return await CategoryRepository.getAll();
        } catch (error) {
            console.error('Error fetching categories:', error);
            throw error;
        }
    }

    static async getCategory(id: number) {
        try {
            return await CategoryRepository.getById(id);
        } catch (error) {
            console.error(`Error fetching category ${id}:`, error);
            throw error;
        }
    }

    static async createCategory(data: Omit<CreateCategoryDto, 'slug'>) {
        try {
            const slug = data.en.name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
            return await CategoryRepository.create({ ...data, slug });
        } catch (error) {
            console.error('Error creating category:', error);
            throw error;
        }
    }

    static async updateCategory(id: number, data: Omit<CreateCategoryDto, 'slug'>) {
        try {

            const slug = data.en.name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
            return await CategoryRepository.update(id, { ...data, slug });
        } catch (error) {
            console.error(`Error updating category ${id}:`, error);
            throw error;
        }
    }

    static async deleteCategory(id: number) {
        try {
            return await CategoryRepository.delete(id);
        } catch (error) {
            console.error(`Error deleting category ${id}:`, error);
            throw error;
        }
    }
}
